
export enum ProjectExamListUpdateType {
	QUESTION = "QUESTION",
	ANSWER = "ANSWER"
};
